import { clsx } from 'clsx';
import type { HTMLAttributes, ReactNode } from 'react';

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  footer?: ReactNode;
  /** Tana ichki bo'shliqsiz (jadval, ro'yxat uchun). */
  flush?: boolean;
  solid?: boolean;
  interactive?: boolean;
  bodyClassName?: string;
}

export function Card({
  title,
  subtitle,
  actions,
  footer,
  flush,
  solid,
  interactive,
  className,
  bodyClassName,
  children,
  ...rest
}: CardProps) {
  const hasHeader = title || subtitle || actions;
  return (
    <section
      className={clsx('kts-card', solid && 'kts-card--solid', interactive && 'kts-card--interactive', className)}
      {...rest}
    >
      {hasHeader && (
        <header className="kts-card__header">
          <div className="kts-card__titles">
            {title && <h3 className="kts-card__title">{title}</h3>}
            {subtitle && <div className="kts-card__subtitle">{subtitle}</div>}
          </div>
          {actions && <div className="kts-card__actions">{actions}</div>}
        </header>
      )}
      <div className={clsx(flush ? 'kts-card__body--flush' : 'kts-card__body', bodyClassName)}>{children}</div>
      {footer && <footer className="kts-card__footer">{footer}</footer>}
    </section>
  );
}
